/**
 * isDemoMode — true when the visitor signed in through the /demo
 * passwordless role tile (which writes `forgeops.demo.identity` to
 * localStorage). In demo mode every gated surface — training tracks,
 * back-office packets, internal QR posters — opens directly so
 * prospects can fully explore the platform without auth walls.
 *
 * Returns false if localStorage is unavailable (SSR / privacy mode).
 */
export function isDemoMode() {
  try {
    return !!window.localStorage.getItem("forgeops.demo.identity");
  } catch {
    return false;
  }
}
